goog.provide("shadow.js.shim.module$react_transition_group");
goog.provide("module$shadow_js_shim_module$react_transition_group");
shadow.js.shim.module$react_transition_group = shadow.js.nativeProvides["react-transition-group"] = shadow$bridge("react-transition-group");
module$shadow_js_shim_module$react_transition_group.default = shadow.js.shim.module$react_transition_group;
